<template>
  <div class='section'>
    <img v-if='window.width > 700' src='../assets/rent-normal.jpeg'>
    <img v-if='window.width < 700' src='../assets/rent-normal-mobile.jpeg'>
    <div class='overlay-content'>
      <div class='section-title'>
        <h1>일반렌트</h1>
      </div>
      <div class='section-title-underline'></div>
      <div class='section-content'>
        <div class='section-content-article'>
          <h2>나에게 맞는 렌터카 찾으셨나요?</h2>
          <p>렌트드림에서는 포르쉐, 람보르기니, 페라리,</p>
          <p>롤스로이스, 벤틀리, 마세라티 아우디 R8 등</p>
          <p>다양한 슈퍼카 & 수입차 & 웨딩카 렌탈 서비스를</p>
          <p>국내 독점으로 제공하고 있습니다.</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>


export default {
  props: ['window'],
  components: {

  },
}
</script>

<style scoped>
  .section {
    margin: 0 auto;
    color: #ffffff;
    position: relative;
  }
  .section img {
    width: 100%;
    z-index: 0;
  }
  .overlay-content {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .section-title-underline {
    border: 2px solid #ffffff;
    text-align: center;
  }
  .section-content {
    width: 90%;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    margin-left: 1em;
  }
  .section-content-article {
    font-size: 2em;
    z-index: 1;
  }
  .section-content-article h2 {
      font-family: s-core5;
  }
  .section-content-article p{
      margin: 0px;
  }
</style>
